import speakerBg from "../../../assets/REMA/speakers/speakerBg.svg";

const SpeakerCardFrontView = ({ speaker }) => {
  return (
    <div
      className="absolute inset-0 w-full h-full flex flex-col"
      style={{ backfaceVisibility: "hidden" }}
    >
      <div className="aspect-[300/295] md:aspect-[286/255] overflow-hidden relative">
        <div className="absolute top-0 left-0 h-full w-full ">
          <img
            src={speakerBg}
            alt="Speaker Background"
            className="w-full h-full object-cover"
          />
        </div>
        <img
          src={speaker.image}
          alt={speaker.name}
          className="h-full md:w-full object-cover transform grayscale"
        />
      </div>

      {/* Speaker Info */}
      <div className="bg-[#11302D] text-white text-center   place-items-center relative flex-1 flex flex-col justify-center ">
        <h3 className="font-semibold text-[20px] leading-tight font-sora transition-colors duration-300">
          {speaker.name}
        </h3>
        <p
          className="text-[#CBF07F] text-base font-medium italic leading-tight mt-[4px] px-1 "
          style={{
            textWrap: "balance",
          }}
        >
          {speaker.title}
        </p>
      </div>
    </div>
  );
};

export default SpeakerCardFrontView;
